import {IReduxArticlesState} from '@src/@interfaces';

export const state: IReduxArticlesState = {
    activeArticleId: null,
    isLoaded: false,
    isLoading: false,
    articles: [],
    errorMessage: null,
};
